import * as React from 'react';
import { connect } from 'react-redux';
import { setFiltroDashboard } from '../../../../actions/dashboardActions';
import { limpiarFiltros } from '../../../../actions/generalActios';
import { fetchSellersFilter } from '../../../../actions/sellersActions';
import Select from 'react-select';
import { customStyle } from '../../../../template/CustomStyle';
import { DropDownArrow } from "../../../../template/CustomStyle";

class FiltroDashboard extends React.Component {
  constructor(props) {
    super(props);
    const today = new Date();
    this.state = {
      fechaDesde: this.props.filtro?.fechaDesde || today.toISOString().split('T')[0],
      fechaHasta: this.props.filtro?.fechaHasta || "",
      verMes: this.props.filtro?.verMes !== undefined ? this.props.filtro?.verMes : false,
      mes: today.getMonth() + 1, // 1-12
      anio: today.getFullYear(),
      seller: { label: "Todos", value: "" },
    }
  }

  componentDidMount() {
    this.checkAndFetchSellers();

    // If no filter exists in Redux or fechaDesde is empty, trigger the default search (Month to Date)
    if (!this.props.filtro || !this.props.filtro.fechaDesde) {
      this.triggerDefaultFilter();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userType !== this.props.userType || prevProps.tipoUsuario != this.props.tipoUsuario) {
      this.checkAndFetchSellers();
    }
  }

  checkAndFetchSellers = () => {
    // Intentamos cargar los sellers si es admin/category (1 o 2). 
    // Usamos PascalCase para los parámetros por si acaso (match listSellersParameters).
    // Forzamos la carga incluso si ya hay sellers, para asegurar que tenemos la paginación correcta (5).
    if (this.props.tipoUsuario == 1 || this.props.tipoUsuario == 2) {
      this.props.fetchSellersFilter({
        Descripcion: "",
        Page: 1,
        PageSize: 100
      });
    }
  }

  triggerDefaultFilter = () => {
    const { fechaDesde, verMes, mes, anio, seller } = this.state;
    // Calculate dates for "Ver Mes" logic
    let finalDesde = fechaDesde;
    let finalHasta = fechaDesde;

    if (verMes) {
      const parts = fechaDesde.split('-');
      if (parts.length === 3) {
        finalDesde = `${parts[0]}-${parts[1]}-01`;
        finalHasta = fechaDesde;
      }
    }

    const filtro = {
      fechaDesde: finalDesde,
      fechaHasta: finalHasta,
      verMes,
      idSeller: seller ? seller.value : null,
      mes,
      anio,
      sellerObj: seller
    };

    this.props.chargeFilterOptions(filtro);
  }

  getYears = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = 0; i < 6; i++) {
      years.push(currentYear - i);
    }
    return years;
  }

  getMonths = () => {
    return [
      { id: 1, name: "Enero" },
      { id: 2, name: "Febrero" },
      { id: 3, name: "Marzo" },
      { id: 4, name: "Abril" },
      { id: 5, name: "Mayo" },
      { id: 6, name: "Junio" },
      { id: 7, name: "Julio" },
      { id: 8, name: "Agosto" },
      { id: 9, name: "Septiembre" },
      { id: 10, name: "Octubre" },
      { id: 11, name: "Noviembre" },
      { id: 12, name: "Diciembre" }
    ];
  }

  onSelectSearchInputSellers = (descripcion, action) => {
    // Solo buscar cuando el usuario escribe, no cuando selecciona
    if (action.action === 'input-change') {
      this.props.fetchSellersFilter({ 
        Descripcion: descripcion,
        Page: 1,
        PageSize: 100
      });
    }
  }

  selectSearchHandler = (option) => {
    this.setState({ seller: option });
  }

  handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    this.setState({
      [name]: type === 'checkbox' ? checked : value
    });
  }

  onFilter = (e) => {
    e.preventDefault();
    const { fechaDesde, verMes, mes, anio, seller } = this.state;
    const { userType, tipoUsuario } = this.props;


    let idSeller = null;
    if (tipoUsuario == 1 || tipoUsuario == 2) {
      idSeller = seller ? seller.value : null;
    }

    // Calcular fechas inicio/fin si es 'verMes'
    let finalDesde = fechaDesde;
    let finalHasta = fechaDesde; // O null, según lógica dashboard

    if (verMes) {
      // Si Ver Mes está activo:
      // Desde: 1° del mes de la fecha seleccionada
      // Hasta: La fecha seleccionada

      if (!fechaDesde) {
        // Fallback porsiacaso, aunque debería tener valor o validarse
        const today = new Date();
        finalHasta = today.toISOString().split('T')[0];
        finalDesde = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split('T')[0];
      } else {
        const d = new Date(fechaDesde + 'T00:00:00'); // Force local time handling or simply string split
        // Queremos el 1ro del mes de esa fecha

        // Forma segura string: YYYY-MM
        const parts = fechaDesde.split('-'); // [2026, 01, 15]
        if (parts.length === 3) {
          finalDesde = `${parts[0]}-${parts[1]}-01`;
          finalHasta = fechaDesde;
        }
      }

    } else {
      // Si Ver Mes está APAGADO:
      // Desde: Fecha seleccionada
      // Hasta: Fecha seleccionada
      finalDesde = fechaDesde;
      finalHasta = fechaDesde;
    }

    const filtro = {
      fechaDesde: finalDesde,
      fechaHasta: finalHasta,
      verMes,
      idSeller, // El dashboard lo necesita
      // Info Extra para re-hidratar el estado si volvemos
      mes,
      anio,
      sellerObj: seller
    };

    this.props.chargeFilterOptions(filtro);
  }

  onClearFilter = () => {
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];

    this.setState({
      fechaDesde: formattedDate,
      fechaHasta: "",
      verMes: false,
      mes: today.getMonth() + 1,
      anio: today.getFullYear(),
      seller: { label: "Todos", value: "" }
    }, () => {
      this.props.limpiarFiltros({ dashboard: true });
      this.triggerDefaultFilter();
    });
  }

  render() {
    const months = this.getMonths();
    const years = this.getYears();

    // Construir lista de opciones segura (sin mutar props)
    const sellersOptions = (this.props.sellers || []).map(item => ({
      label: item.label,
      value: item.value.toString()
    }));

    // Agregar "Todos" al principio
    sellersOptions.unshift({ value: "", label: "Todos" });

    return (
      <div className="card card-body filter-card mb-3"
        style={{
          background: 'linear-gradient(to right, #fff0f0, #ffffff)',
          border: 'none',
          boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
        }}>
        <form className="row form-material justify-content-start align-items-end"
          onSubmit={this.onFilter}
          onReset={this.onClearFilter}
        >
          {/* Switch Ver Mes */}
          <div className="col-12 col-md-auto mb-3 mb-md-0 d-flex align-items-center" style={{ minHeight: '60px' }}>
            <div className="form-check form-switch custom-switch ps-0">
              <input
                type="checkbox"
                id="checkVerMes"
                name="verMes"
                className="form-check-input ms-0 me-2"
                style={{ cursor: 'pointer', width: '2.5rem', height: '1.25rem' }}
                onChange={this.handleChange}
                checked={this.state.verMes}
              />
              <label
                className="form-check-label label-oscura"
                htmlFor="checkVerMes"
                style={{ cursor: 'pointer', fontWeight: 500, fontSize: '0.9rem', paddingTop: '2px' }}>
                Ver por Mes
              </label>
            </div>
          </div>

          {/* Siempre mostramos input Fecha, el switch define comportamiento */}
          <div className="col-12 col-md-auto mb-3 mb-md-0 d-flex align-items-center" style={{ minHeight: '60px' }}>
            <div className="form-group mb-0">
              <label className="label-oscura font-weight-bold">Fecha</label>
              <input
                type="date"
                name="fechaDesde"
                className="form-control"
                onChange={this.handleChange}
                value={this.state.fechaDesde}
              />
              {this.state.verMes ? <small className="text-muted d-block mt-1">Acumulado desde inicio de mes</small> : <small className="text-muted d-block mt-1">Datos del día</small>}
            </div>
          </div>

          {(this.props.tipoUsuario == 1 || this.props.tipoUsuario == 2) &&
            <div className="col-6 col-sm-4 col-md-3">
              <div className="form-group mb-0">
                <label className="label-oscura font-weight-bold">Seller</label>
                <Select
                  name="seller"
                  value={this.state.seller}
                  options={sellersOptions}
                  onChange={this.selectSearchHandler}
                  onInputChange={this.onSelectSearchInputSellers}
                  components={{ DropdownIndicator: () => DropDownArrow }}
                  styles={{
                    ...customStyle,
                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                    menu: base => ({ ...base, zIndex: 9999 })
                  }}
                  menuPortalTarget={document.body}
                  placeholder="Buscar Seller..."
                />
              </div>
            </div>
          }

          <div className="col-12 col-md-auto ms-auto mt-3 mt-md-0">
            <div className="d-flex gap-2">
              <button type='submit' className="btn btn-sm background-rojo-megatone text-white px-3 shadow-sm" disabled={this.props.isLoading}>
                <i className="mdi mdi-magnify mr-1"></i> Buscar
              </button>
              <button type='reset' className="btn btn-sm btn-outline-secondary px-3 shadow-sm">
                Limpiar
              </button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}


const mapStateToProps = state => ({
  isLoading: state.dashboard.isLoading,
  idSeller: state.general.idSeller,
  userType: state.general.userType,
  tipoUsuario: state.general.tipoUsuario,
  sellers: state.sellers.filteredSellers,
});

export default connect(mapStateToProps, {
  setFiltroDashboard,
  limpiarFiltros,
  fetchSellersFilter // Mantener si otras partes lo usan, pero aca ya no es critico para el dropdown
})(FiltroDashboard)